export const PER_PAGE = 24;
export const ORDER_BY = 'recent';
export const DEFAULT_VISITED_PAGE = { new: false, sent: false };

export interface DEFAULT_VISITED_PAGE_PROPS {
  new: boolean;
  sent: boolean;
}
